import { Button, Grid, Paper } from '@material-ui/core'
import React from 'react'
import API from '../../api/api'
import { createCategory } from '../../api/mutations/categoryMutations.js'
import { addProduct, deleteProduct, updateProduct } from '../../api/mutations/productMutations'
import { categoriesQuery } from '../../api/queries/categoryQueries'
import { productsQuery } from '../../api/queries/productQueries'
import { ratesQuery } from '../../api/queries/rateQueries'
import Alert from '../../components/AlertSnackbar/index.jsx'
import CategoryForm from '../../components/Form/CategoryForm/index.jsx'
import ProductForm from '../../components/Form/ProductForm/index.jsx'
import Select from '../../components/Form/SelectForm'
import CategoryTable from '../../components/Table/CategoryTable'
import { ALERT_SEVERITY, PAGE_TYPE_HK } from '../../utils/constants'
import { productsHkOrFb } from '../../utils/product'

import { sortArrayByValue } from '../../utils/functions'

const CATEGORY_BRAND = {
  category: 'category',
  brand: 'brand',
}

export default class Categories extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      type: this.props?.match?.params?.type,
      categories: [],
      brands: [],
      products: [],
      allProducts: [],
      rates: [],
      category: 0,
      brand: 0,
      openAddBrandForm: false,
      openAddCategoryForm: false,
      openUpdateBrandForm: false,
      initProduct: { name: '', code: '', category: '', rate: '' },
      alert: {
        open: false,
        message: '',
        severity: '',
      },
    }
  }

  async componentDidMount() {
    const categoriesResult = await this._fetchCategory()
    const ratesResults = await API.queryAPI(ratesQuery)
    const productsResult = await this._fetchProduct()

    this.setState({
      categories: [...(categoriesResult?.categories ?? [])],
      brands: [...(productsResult?.filteredProducts ?? [])],
      products: [...(productsResult?.products ?? [])],
      allProducts: [...(productsResult?.products ?? [])],
      rates: [...(ratesResults?.rates ?? [])],
    })
  }

  _openUpdateBrandForm(product) {
    this.setState({
      openUpdateBrandForm: true,
      initProduct: {
        productId: product.id,
        name: product.name,
        code: product.code,
        category: product.category.id,
        rate: product.rate.id,
      },
    })
  }

  async _deleteProduct(productId) {
    await API.queryAPI(deleteProduct(productId))
    const productsResult = await this._fetchProduct()
    this.setState({
      alert: { open: true, severity: ALERT_SEVERITY.success, message: 'Le produit a été supprimé' },
      brands: [...productsResult.filteredProducts],
      products: [...productsResult.products],
    })
  }

  async _fetchCategory() {
    return await API.queryAPI(categoriesQuery(this.state.type === PAGE_TYPE_HK))
  }

  async _fetchProduct() {
    const productsResult = await API.queryAPI(productsQuery)
    productsResult.products = productsHkOrFb(productsResult.products, this.state.type)

    const filteredProducts = productsResult.products.map((product) => ({ id: product.id, name: product.name }))

    const products = productsResult.products.map((product) => ({
      id: product.id,
      categoryId: product.category.id,
      category: product.category.name,
      code: product.code,
      name: product.name,
      update: (
        <Button variant="contained" size="small" color="secondary" onClick={() => this._openUpdateBrandForm(product)}>
          Modifier
        </Button>
      ),
      delete: (
        <Button variant="contained" size="small" color="secondary" onClick={() => this._deleteProduct(product.id)}>
          Supprimer
        </Button>
      ),
    }))

    return { filteredProducts: filteredProducts, products: products }
  }
  _getList(items) {
    return [{ id: 0, name: 'Tout afficher' }].concat(sortArrayByValue(items, 'name'))
  }

  _handleFilter(selectedOption, optionId, initFilter) {
    if (optionId !== 0) {
      const productsFilteredByCat = [...this.state.allProducts]

      const res = productsFilteredByCat.filter((product) =>
        selectedOption === CATEGORY_BRAND.category ? product.categoryId === optionId : product.id === optionId,
      )
      this.setState({
        [selectedOption]: optionId,
        products: res,
        [initFilter]: 0,
      })
    } else {
      this.setState({
        products: this.state.allProducts,
        [selectedOption]: 0,
        [initFilter]: 0,
      })
    }
  }

  _handleClickAddBrandCategory(e) {
    e.currentTarget.name === 'addBrand'
      ? this.setState({ openAddBrandForm: true })
      : this.setState({ openAddCategoryForm: true })
  }

  _handleClose() {
    this.state.openAddCategoryForm
      ? this.setState({ openAddCategoryForm: false })
      : this.setState({ openAddBrandForm: false, openUpdateBrandForm: false })
  }

  async _handleValidateProduct(form) {
    const newProduct = this.state.openUpdateBrandForm
      ? await API.queryAPI(
          updateProduct(this.state.initProduct.productId, form.name, form.code, form.category, form.rate),
        )
      : await API.queryAPI(addProduct(form.code, form.name, form.category, form.rate))

    if (!!newProduct) {
      const productsResult = await this._fetchProduct()
      this.setState({
        openAddBrandForm: false,
        openUpdateBrandForm: false,
        alert: { open: true, severity: ALERT_SEVERITY.success, message: 'Le produit a été ajouté' },
        brands: [...productsResult.filteredProducts],
        products: [...productsResult.products],
      })
    } else
      this.setState({
        openAddBrandForm: false,
        openUpdateBrandForm: false,
        alert: { open: true, severity: ALERT_SEVERITY.warning, message: "Le produit n'a pas pu être ajouté" },
      })
  }
  async _handleValidateCategory(form) {
    const newCategory = await API.queryAPI(createCategory(form.code, form.name, this.state.type))
    if (!!newCategory) {
      const categoriesResult = await this._fetchCategory()
      this.setState({
        openAddCategoryForm: false,
        alert: { open: true, severity: ALERT_SEVERITY.success, message: 'La catégorie a été ajoutée' },
        categories: [...categoriesResult.categories],
      })
    } else
      this.setState({
        openAddBrandForm: false,
        alert: { open: true, severity: ALERT_SEVERITY.warning, message: "La catégorie n'a pas pu être ajoutée" },
      })
  }

  render() {
    return (
      <>
        <Alert
          open={this.state.alert.open}
          severity={this.state.alert.severity}
          text={this.state.alert.message}
          onClose={() => this.setState({ alert: { ...this.state.alert, open: false } })}
        />
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <Select
              name="categories"
              select
              value={this.state.category}
              onChange={(e) => this._handleFilter(CATEGORY_BRAND.category, e.target.value, CATEGORY_BRAND.brand)}
              label="Catégories"
              items={this._getList(this.state.categories)}
              valueName="id"
              text="name"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Select
              name="brands"
              select
              value={this.state.brand}
              onChange={(e) => this._handleFilter(CATEGORY_BRAND.brand, e.target.value, CATEGORY_BRAND.category)}
              label="Marques"
              items={this._getList(this.state.brands)}
              valueName="id"
              text="name"
            />
          </Grid>
          <Grid item xs={12} component={Paper}>
            <CategoryTable products={this.state.products} onClick={(e) => this._handleClickAddBrandCategory(e)} />
          </Grid>
          <CategoryForm
            open={this.state.openAddCategoryForm}
            title="Ajouter une catégorie"
            onValidate={(form) => this._handleValidateCategory(form)}
            onClose={() => this._handleClose()}
          />
          <ProductForm
            open={this.state.openAddBrandForm || this.state.openUpdateBrandForm}
            title={this.state.openAddBrandForm ? 'Ajouter une marque' : 'Modifier une marque'}
            onValidate={(form) => this._handleValidateProduct(form)}
            onClose={() => this._handleClose()}
            categories={this.state.categories}
            rates={this.state.rates}
            initForm={this.state.initProduct}
            updateForm={this.state.openUpdateBrandForm}
          />
        </Grid>
      </>
    )
  }
}
